import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row overflow-auto" }
const _hoisted_2 = { class: "me-4" }
const _hoisted_3 = { class: "me-4" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = { class: "me-4" }
const _hoisted_6 = { class: "me-4" }
const _hoisted_7 = { class: "me-4" }
const _hoisted_8 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-0",
    columns: this.columns,
    items: this.items
  }, {
    notificationOptionsHeader: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('project.edit.objectPlannerDefinitions.notificationColumnCaption')) + " ", 1),
      _createElementVNode("div", null, [
        _createElementVNode("small", null, _toDisplayString(_ctx.$t('project.edit.objectPlannerDefinitions.notificationColumnSubCaption')), 1)
      ])
    ]),
    name: _withCtx(({ item }) => [
      _createVNode(_component_TextInput, {
        mode: "flex",
        modelValue: item.objectPlannerPositionDefinition.name,
        "onUpdate:modelValue": ($event: any) => ((item.objectPlannerPositionDefinition.name) = $event),
        inputClass: (item.objectPlannerPositionDefinition.name != null && item.objectPlannerPositionDefinition.name.length>0) ? '' : 'mustField'
      }, null, 8, ["modelValue", "onUpdate:modelValue", "inputClass"])
    ]),
    roleType: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        mode: "flex",
        options: this.roleTypeOptions,
        modelValue: item.objectPlannerPositionDefinition.roleTypeId,
        "onUpdate:modelValue": ($event: any) => ((item.objectPlannerPositionDefinition.roleTypeId) = $event),
        selectClass: item.objectPlannerPositionDefinition.roleTypeId != null ? '' : 'mustField'
      }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "selectClass"])
    ]),
    notificationOptions: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            modelValue: item.notificateReleasedPositiv,
            "onUpdate:modelValue": ($event: any) => ((item.notificateReleasedPositiv) = $event),
            label: _ctx.$t('project.edit.objectPlannerDefinitions.notificateReleasedPositiv')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            modelValue: item.notificateReleasedNegative,
            "onUpdate:modelValue": ($event: any) => ((item.notificateReleasedNegative) = $event),
            label: _ctx.$t('project.edit.objectPlannerDefinitions.notificateReleasedNegativ')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            modelValue: item.notificateInvalidatedVersion,
            "onUpdate:modelValue": ($event: any) => ((item.notificateInvalidatedVersion) = $event),
            label: _ctx.$t('project.edit.objectPlannerDefinitions.notificateInvalidatedVersion')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            modelValue: item.notificateInvalidatedAll,
            "onUpdate:modelValue": ($event: any) => ((item.notificateInvalidatedAll) = $event),
            label: _ctx.$t('project.edit.objectPlannerDefinitions.notificateInvalidatedAll')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            modelValue: item.notificateDeleted,
            "onUpdate:modelValue": ($event: any) => ((item.notificateDeleted) = $event),
            label: _ctx.$t('project.edit.objectPlannerDefinitions.notificateDeleted')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            modelValue: item.notificateRevised,
            "onUpdate:modelValue": ($event: any) => ((item.notificateRevised) = $event),
            label: _ctx.$t('project.edit.objectPlannerDefinitions.notificateRevised')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
        ])
      ])
    ]),
    actions: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-outline-danger",
          "data-bs-toggle": "tooltip",
          title: _ctx.$t('general.delete'),
          onClick: ($event: any) => (_ctx.deleteItem(item))
        }, _hoisted_11, 8, _hoisted_9)
      ])
    ]),
    _: 1
  }, 8, ["columns", "items"]))
}